<template>
  <div
    id="question-list"
    class="overflow-auto h-56 md:h-96 pt-3">
    <ul
      v-if="props.allQuestions"
      id="list"
      class="px-2">
      <template
        v-for="(question, index) in props.allQuestions"
        :key="question.id">
        <li
          :class="{ 'bg-white rounded-md pl-4 border-4 border-gray-300' : isCurrentAnsweredQuestion(question.id) }"
          class="w-full text-base whitespace-nowrap mb-1 px-2 py-1 cursor-pointer box-border bg-white rounded-md pl-4 border-2"
          @click="onClickedQuestionLink(question.id)">
          <span class="flex">
            <svg
              v-if="isCorrect(question.id)"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2 h-6 w-6 inline text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2 inline h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="rgb(29, 78, 216)">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
            <p>{{ `${index+1}問目` }}</p>
          </span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup>
import {
  computed, reactive, onUpdated, watch,
} from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { storeToRefs } from 'pinia'
import defineStore from '../../../stores/user-answer-status'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: String,
    default: null,
  },
  question: {
    type: Object,
    default: () => {},
  },
  questions: {
    type: Array,
    default: () => [],
  },
  questionAnswers: {
    type: Array,
    default: () => [],
  },
  questionIndex: {
    type: Number,
    default: 0,
  },
  isClickedQuestionList: {
    type: Boolean,
    default: false,
  },
  allAnswerQuestionAnswers: {
    type: Object,
    default: () => ({}),
  },
})

const duplicateQuestionIds = computed(() => props.questions.filter((id) => props.questionAnswers.includes(id)))

const isAnsweredQuestion = (id) => duplicateQuestionIds.value.includes(id)
const isCurrentAnsweredQuestion = (id) => id === props.question.id

const form = reactive(Inertia.form({
  examination: props.examination,
  type: props.type,
  question_id: null,
  question: null,
  answer_type: null,
  index: null,
}))

const store = defineStore()
const { currentQuestionId } = storeToRefs(store)

watch(
  () => props.question.id,
  () => {
    store.changeCurrentQuestionId(props.question.id)
  },
)

const isCorrect = (id) => {
  const answerObject = props.allAnswerQuestionAnswers.find((questionAnswer) => questionAnswer.question_id === id)
  let answerType = 0
  if (answerObject) {
    answerType = answerObject.answer_type
  }
  return (answerType === 1)
}

const onClickedQuestionLink = async (id) => {
  store.changeCurrentQuestionId(props.question.id)
  const index = props.allQuestions.findIndex((question) => question.id === id)
  const targetQuestion = props.allQuestions[index]
  // form.question_id = currentQuestionId.value
  // form.question = targetQuestion.id
  // form.index = index
  // form.post(route('commentary'))

  Inertia.get(route('commentary', {
    examination: props.examination.id,
    type: props.type,
    question_id: currentQuestionId.value,
    question: targetQuestion.id,
    index,
  }))

  if (targetQuestion.id !== currentQuestionId.value) {
    store.initializeState()
  }
}

onUpdated(() => {
  if (!props.isClickedQuestionList) {
    const listDom = document.querySelector('#list')
    listDom.children[props.questionIndex].scrollIntoView(false)
  }
})
</script>
<style scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 50, .5);
  border-radius: 10px;
  box-shadow:0 0 0 1px rgba(255, 255, 255, .3);
}
</style>
